import { VeryCompactUserResponse } from '../account';
import { TmServiceProvidersResponse } from './TmServiceProviderResponse';

export type RegionId = string;

export interface UserMapResponse {
  id: string;
  firstName: string;
  lastName: string;
  geoJson?: any | null;
}

export interface TmRegionResponse {
  id: RegionId;
  name: string;
  user?: VeryCompactUserResponse;
  geoJson?: any;
  providers?: TmRegionResponseWithProviders[];
  salesReps?: UserMapResponse[];
}

export type TmRegionResponseWithProviders = Pick<TmServiceProvidersResponse, 'id' | 'name'> & {
  menuOrder: number;
};

export enum PaymentType {
  weekly = 'weekly',
  monthly = 'monthly',
  vcc = 'vcc',
  credit_card = 'credit_card',
  mid_mos = 'mid_mos',
  other = 'other',
}

export const PaymentTypeStatus = [
  PaymentType.weekly,
  PaymentType.monthly,
  PaymentType.vcc,
  PaymentType.credit_card,
  PaymentType.mid_mos,
  PaymentType.other,
];
